import {observer} from "mobx-react-lite";
import BasePageLayout from "../../../components/layouts/base-page-layout/base-page-layout";
import ShopsSelector from "../../../components/shops-selector/shops-selector";
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import {FormFieldLine} from "../../../components/form-field-line/form-field-line";
import React from "react";
import manageMerchantsPlansPageStore from "./stores/manage-merchants-plans-page-store";
import EditorPageLayout from "../../../components/layouts/editor-page/editor-page-layout";
import Card from "../../../components/layouts/card/card";
import ControlGroup from "../../../components/layouts/control-group/control-group";
import {FormField} from "../../../components/form-field/form-field";
import {Input} from "../../../components/inputs/input/input";
import {Note, NOTE_TYPE} from "../../../components/note/note";
import FontBody1 from "../../../components/fonts/font-body1/font-body1";
import Divider from "../../subscription-plans/components/plan-info/divider/divider";
import {Toggle} from "../../../components/inputs/toggle/toggle";
import AdminManageWalletCard from "./wallet/admin-manage-wallet-card";

interface IManageMerchantsPlans {

}

const AdminManageMerchantsPlans: React.FC<IManageMerchantsPlans> = observer(() => {
    return <BasePageLayout title="Manage Merchants Plans">
        <EditorPageLayout
            toolbar={
                {
                    hasBack: false,
                    hasLocalesSelector: false,
                    saveButton: {
                        hasChanges: manageMerchantsPlansPageStore.hasChanges(),
                        onClick: manageMerchantsPlansPageStore.save,
                        disabled: !manageMerchantsPlansPageStore.hasChanges() ||
                            manageMerchantsPlansPageStore.isNotAllRgoMarginsSet() ||
                            manageMerchantsPlansPageStore.isNotAllCoverageMarginsSet()
                    }
                }
            }
        >
            <ListLayout>
                <FormFieldLine label="Select merchant" note="Only one selected merchant allowed at time">
                    <div className="shops-selector-wrapper">
                        <div>
                            <ShopsSelector
                                onChange={manageMerchantsPlansPageStore.setSelectedMerchant}
                                disabled={!!manageMerchantsPlansPageStore.getSelectedMerchant()}
                            />
                        </div>
                    </div>
                </FormFieldLine>

                {manageMerchantsPlansPageStore.getSelectedMerchantPlanModel() &&
                    <FormFieldLine label="Selected plan">
                        <div>
                            <div>
                              <FontBody1>
                                  Plan ID: {manageMerchantsPlansPageStore.getSelectedMerchantPlanModel()?.id}
                              </FontBody1>
                            </div>
                            <div>
                                <FontBody1>
                                    Plan name: {manageMerchantsPlansPageStore.getSelectedMerchantPlanModel()?.name}
                                </FontBody1>
                            </div>
                            <div>
                                <FontBody1>
                                    Plan internal name: {manageMerchantsPlansPageStore.getSelectedMerchantPlanModel()?.internal_name}
                                </FontBody1>
                            </div>
                        </div>
                    </FormFieldLine>
                }

                {!manageMerchantsPlansPageStore.getSelectedMerchantPlanModel() &&
                    <>
                        <Note
                            type={NOTE_TYPE.INFORMATION}
                            body={
                                <FontBody1>
                                    Merchant not selected or don't have the plan.
                                </FontBody1>
                            }
                        />
                    </>
                }

                {!!manageMerchantsPlansPageStore.getSelectedMerchantPlanModel() &&
                    <>

                        {manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism() &&
                            <Note
                                type={NOTE_TYPE.INFORMATION}
                                body={
                                    <FontBody1>
                                        Margins could be changed only for plans with MIXED or TRANSACTIONAL billing
                                        mechanisms, the plan doesn't have Return Guard or Ship by ReturnGo features
                                    </FontBody1>
                                }
                            />
                        }

                        {!manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism() &&
                            <>
                                <Card
                                    toolbar={{
                                        title: "Billing fields"
                                    }}
                                >

                                    <FormFieldLine
                                        label="Fake charges for transactions"
                                        note="When checked, daily transactions will not be charged"
                                    >
                                        <Toggle
                                            label=""
                                            checked={manageMerchantsPlansPageStore.getIsUsageCalculationMechanismIsFake()}
                                            onChange={manageMerchantsPlansPageStore.setIsUsageCalculationMechanismIsFake}
                                        />
                                    </FormFieldLine>

                                    <ControlGroup>
                                        <FormField label="Ship by RGO fixed margin">
                                            <Input
                                                temp
                                                min={0}
                                                type="number"
                                                value={manageMerchantsPlansPageStore.getShipByReturnGoLabelCostFixedMargin()}
                                                onChange={manageMerchantsPlansPageStore.setShipByReturnGoLabelCostFixedMargin}
                                                disabled={manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism()}
                                                required={manageMerchantsPlansPageStore.isNotAllRgoMarginsSet()}
                                            />
                                        </FormField>

                                        <FormField label="Ship by RGO relative margin">
                                            <Input
                                                temp
                                                min={0}
                                                type="number"
                                                value={manageMerchantsPlansPageStore.getShipByReturnGoLabelCostRelativeMargin()}
                                                onChange={manageMerchantsPlansPageStore.setShipByReturnGoLabelCostRelativeMargin}
                                                disabled={manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism()}
                                                required={manageMerchantsPlansPageStore.isNotAllRgoMarginsSet()}
                                            />
                                        </FormField>

                                    </ControlGroup>

                                    <Divider/>

                                    <ControlGroup>

                                        <FormField label="Coverage label cost fixed margin">
                                            <Input
                                                temp
                                                min={0}
                                                type="number"
                                                value={manageMerchantsPlansPageStore.getCoverageLabelCostFixedMargin()}
                                                onChange={manageMerchantsPlansPageStore.setCoverageByReturnGoLabelCostFixedMargin}
                                                disabled={manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism()}
                                                required={manageMerchantsPlansPageStore.isNotAllCoverageMarginsSet()}
                                            />
                                        </FormField>

                                        <FormField label="Coverage label cost relative margin">
                                            <Input
                                                temp
                                                min={0}
                                                type="number"
                                                value={manageMerchantsPlansPageStore.getCoverageLabelCostRelativeMargin()}
                                                onChange={manageMerchantsPlansPageStore.setCoverageByReturnGoLabelCostRelativeMargin}
                                                disabled={manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism()}
                                                required={manageMerchantsPlansPageStore.isNotAllCoverageMarginsSet()}
                                            />
                                        </FormField>

                                        <FormField label="Coverage revenue share (our part)">
                                            <Input
                                                temp
                                                min={0}
                                                type="number"
                                                value={manageMerchantsPlansPageStore.getCoverageRevenueShare()}
                                                onChange={manageMerchantsPlansPageStore.setCoverageRevenueShare}
                                                disabled={manageMerchantsPlansPageStore.isNotRelevantUsagesCalculationMechanism()}
                                                required={manageMerchantsPlansPageStore.isNotAllCoverageMarginsSet()}
                                            />
                                        </FormField>

                                    </ControlGroup>
                                </Card>
                            </>
                        }
                    </>
                }

                {
                    manageMerchantsPlansPageStore.getSelectedMerchant() && <AdminManageWalletCard shopId={manageMerchantsPlansPageStore.getSelectedMerchant()?.id!}/>
                }
            </ListLayout>
        </EditorPageLayout>
    </BasePageLayout>
});

export default AdminManageMerchantsPlans;